import { render, staticRenderFns } from "./home8.vue?vue&type=template&id=658f2820&scoped=true&"
import script from "./home8.vue?vue&type=script&lang=js&"
export * from "./home8.vue?vue&type=script&lang=js&"
import style0 from "./home8.vue?vue&type=style&index=0&id=658f2820&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f2820",
  null
  
)

export default component.exports